import React from 'react';
import {withTranslation} from "react-i18next";
import '../style/loader.css';

let LoadingComponent = ({t}) => {
	return <div className="lds-ellipsis">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>;
};

export default withTranslation() (LoadingComponent)